import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "homeListTitle",
  props: {
    title: {
      type: String,
      default: ""
    },
    routerPath: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    var router = useRouter();

    var titleClick = function titleClick(routerPath) {
      router.push(routerPath);
    };

    return {
      titleClick: titleClick
    };
  },
  components: {}
});